import { format } from 'date-fns';

export default function BusinessDays(numberOfValidDays = 10) {
  const labelFormat = 'EEEE, MMMM d';
  const valueFormat = 'MM-dd-yyyy';

  const dates = [];
  const currentDate = new Date();

  while (dates.length < numberOfValidDays) {
    if (![0, 6].includes(currentDate.getDay())) {
      const date = {
        label: format(currentDate, labelFormat),
        value: format(currentDate, valueFormat)
      };
      dates.push(date);
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
}
